import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { APP_SETTINGS } from '../../shared/models/backofficeConfiguration';
import { ExecuteService } from '../../shared/services/executeService.service';
import { ErrorHandlerService } from '../../shared/services/errorHandler.service';
import { Observable } from 'rxjs';

@Injectable()
export class LeadsService {
  private leadApiURL = APP_SETTINGS.LeadApiUrl;

  constructor(
    private executeService: ExecuteService,
    private errorHandler: ErrorHandlerService) {
  }
  public Delete(email: string): Observable<any> {
    const url = this.leadApiURL + 'api/v1/UserLead/' + email;
    return this.executeService.ExecuteWithToken('delete', url)
      .pipe(
        catchError(this.errorHandler.handleAndThrowError('LeadsService_Delete', null, true))
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/users/services/leads.service.ts